import { Component, OnInit, Input } from '@angular/core';
import { SucursalService } from '../../../services/sucursal.service';
import * as Chart from 'chart.js';
import * as numeral from 'numeral';

@Component({
  selector: 'chart-sucursal-mas-ventas',
  templateUrl: './sucursal-mas-ventas.component.html',
  styleUrls: ['./sucursal-mas-ventas.component.css'],
  providers: [SucursalService]
})

export class SucursalMasVentasComponent implements OnInit {
    @Input() periodo: String;
    @Input() fecha_inicio;
    @Input() fecha_fin;
    public loading: boolean;
    public data: Array<any>;
    private myChart: any;

    constructor(
        private sucursalService: SucursalService,
    ) {
        this.loading = false;
        this.data = [];
    }

    ngOnInit() {
        this.initChart();
    }

    initChart(periodo?){
        this.periodo = periodo?periodo:this.periodo;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(parseFloat(e.valor).toFixed(2));
                    labels.push(e.nombre);
                });

                this.drawChart(data, labels);
                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    getData(){
        return new Promise((resolve, reject) => {
            let qs = "";

            if(this.periodo == "otro"){
                this.sucursalService.getMasVentas("?periodo=" + this.periodo+"&fecha_inicio="+this.fecha_inicio+"&fecha_fin="+this.fecha_fin).subscribe(
                    res => {
                        this.data = res.data;
                        resolve();
                    },
                    err => {
                        this.data = [];
                        reject(err);
                    }
                );
            }else{
                this.sucursalService.getMasVentas("?periodo=" + this.periodo).subscribe(
                    res => {
                        this.data = res.data;
                        resolve();
                    },
                    err => {
                        this.data = [];
                        reject(err);
                    }
                );

               
            }
            
            
            
            
        });
    }

    updateDataChart(periodo,fecha_inicio,fecha_fin){
        this.periodo = periodo?periodo:this.periodo;
        this.fecha_inicio = fecha_inicio?fecha_inicio:this.fecha_inicio;
        this.fecha_fin = fecha_fin?fecha_fin:this.fecha_fin;

        this.loading = true;
        this.getData().then(
            res => {
                let data = [];
                let labels = [];

                this.data.forEach(e => {
                    data.push(parseFloat(e.valor).toFixed(2));
                    labels.push(e.nombre);
                });

                //this.drawChart(data, labels);
                this.myChart.data.datasets[0].data = data;
                this.myChart.data.labels = labels;
                this.myChart.update();

                this.loading = false;
            },
            err => {
                this.loading = false;
            }
        );
    }

    drawChart(data, labels){
        var ctx = document.getElementById("cvsSucursalesImportantes");

        this.myChart = new Chart(ctx,{
            type: 'pie',
            data: {
                datasets: [{
                    data: data,
                    backgroundColor: [
                        '#7baaf7',
                        '#57bb8a',
                        '#80deea',
                        '#80cbc4',
                        '#e6ee9c',
                    ],
                    borderColor: [
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                        '#FFF',
                    ],
                    borderWidth: 1
                }],
                labels: labels
            },
            options: {
                legend: {
                    position: 'top'
                },
                tooltips: {
                    enabled: true,
                    mode: 'single',
                    callbacks: {
                        //title: function (tooltipItem, data) {
                        //    return "Día " + data.labels[tooltipItem[0].index]; 
                        //},
                        label: function(tooltipItems, data) {
                            return "$ " + numeral(data.datasets[0].data[tooltipItems.index]).format('0,0.00');
                        },
                        footer: function (tooltipItem, data) {
                            let total = 0;
                            data.datasets[0].data.forEach(value => total += parseFloat(value));
                            let porcent = (parseFloat(data.datasets[0].data[tooltipItem[0].index]) / total) * 100;
                            return numeral(porcent).format('0,0.00') + " %";
                        }
                    }
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/charts/sucursal-mas-ventas/sucursal-mas-ventas.component.ts